import service from "../services/elixio-connect-service.js";
import { pick } from "lodash";

export const state = () => ({
  services: [],
});

export const mutations = {
  SET_SERVICES: (state, services) => {
    state.services = services;
  },
};

export const actions = {
  async subscribe({ commit, dispatch }, data) {
    const { organizationId, payload } = data;
    return await service.subscribe(organizationId, payload);
  },

  async updateConfigs({ commit, dispatch }, data) {
    const { organizationId, payload } = data;
    return await service.updateConfigs(organizationId, payload);
  },

  async toggleServiceActivation({ commit, dispatch }, data) {
    const { organizationId, payload } = data;
    return await service.toggleServiceActivation(organizationId, payload);
  },

  async getModules({ commit, dispatch }) {
    return await service.getModules(this.$axios);
  },

  async refreshService({ commit, dispatch }, data) {
    const { organizationId, serviceId } = data;
    return await service.refreshService(organizationId, serviceId);
  },

  async getAllServices({ commit, dispatch }, data) {
    return await service.getAllServices(data, this.$axios);
  },

  async syncBatch({ commit, dispatch }, data) {
    const { organizationId, serviceType, createdAfter } = data;
    return await service.syncBatch(organizationId, serviceType, createdAfter);
  },

  async getBatch({ commit, dispatch }, data) {
    const { organizationId, batchId } = data;
    return await service.getBatch(organizationId, batchId);
  },

  // Shipments
  async getAllShipments({ commit }, { params }) {
    console.log(params);
    const { data } = await service.getAllShipments(params);
    return data;
  },

  async getShipments({ commit }, { shippableType, shippableId }) {
    const { data } = await service.getShipments(shippableType, shippableId);
    return data;
  },

  async getShipment({ commit }, { shipmentId, serviceId }) {
    const { data } = await service.getShipment(shipmentId, serviceId);
    return data;
  },

  async estimateShipment({ commit }, { shippableType, shippableId, payload }) {
    const { data } = await service.estimateShipment(
      shippableType,
      shippableId,
      payload
    );
    return data;
  },

  async editEstimation({ commit }, { shipmentId, payload }) {
    const { data } = await service.editEstimation(shipmentId, payload);
    return data;
  },

  async destroyEstimation({ commit }, { shipmentId }) {
    const { data } = await service.destroyEstimation(shipmentId);
    return data;
  },

  async createShipment({ commit }, { shipmentId, serviceId }) {
    const { data } = await service.createShipment(shipmentId, serviceId);
    return data;
  },

  async createPickup({ commit }, { shipmentId, pickupDetails }) {
    const { data } = await service.createPickup(shipmentId, pickupDetails);
    return data;
  },

  async cancelShipment({ commit }, { shipmentId }) {
    const { data } = await service.cancelShipment(shipmentId);
    return data;
  },

  async cancelPickup({ commit }, { shipmentId }) {
    const { data } = await service.cancelPickup(shipmentId);
    return data;
  },

  async printShipmentLabel({ commit }, { shipmentId, labelType }) {
    const { data } = await service.printShipmentLabel(shipmentId, labelType);
    return data;
  },

  async trackShipment({ commit }, { shipmentId }) {
    const { data } = await service.trackShipment(shipmentId);
    return data;
  },
};

const getters = {
  services: (state) => state.services,
};

const elixioConnectModule = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

export default elixioConnectModule;
